<template>
  <div class="medication-dispense-group-view">
    <div v-if="medicationDispenseGroup" class="medication-dispense-group-view__header">
      <h5 class="medication-dispense-group-view__title">
        <i class="fas fa-clipboard-list" /> Detalle de la dispensación
      </h5>
      <router-link :to="medicationRequestLink">
        Ver detalle de la prescripción
      </router-link>
    </div>
    <div
      v-if="!medicationDispenseGroup && fetchingMedicationDispenseGroup"
      class="medication-dispense-group-view__loader"
      element-loading-text="Cargando detalles de las dispensaciones" />
    <div v-if="medicationDispenseGroup" class="medication-dispense-group-view__body">
      <div v-for="medicationDispense in formattedMedicationDispenseGroup" :key="`medication-dispense-${medicationDispense.id}`" class="card">
        <div class="card-body">
          <h4>{{ medicationDispense.display }}</h4>
          <h6>{{ medicationDispense.date | dateTime }}</h6>
        </div>
      </div>
    </div>
    <div v-if="medicationDispenseGroup" class="medication-dispense-group-view__footer">
      <button @click="$router.push('/prescription-scan')" class="btn btn-primary float-right">
        Realizar Nueva Dispensación
      </button>
    </div>
  </div>
</template>

<script>
import _get from 'lodash/get';

export default {
  name: 'MedicationDispenseGroupView',
  data() {
    return {
      medicationDispenseGroup: null,
      fetchingMedicationDispenseGroup: false
    };
  },
  computed: {
    formattedMedicationDispenseGroup() {
      return _get(this.medicationDispenseGroup, 'contained', []).map(medicationDispense => {
        return {
          id: medicationDispense.id,
          display: _get(medicationDispense, 'data.medicationReference.display', ''),
          date: _get(medicationDispense, 'created_at', '')
        };
      });
    },
    medicationRequestLink() {
      return `/prescription-dispense/${this.$route.params.medicationRequestId}`;
    }
  },
  created() {
    this.fetchMedicationDispenseGroup();
  },
  methods: {
    fetchMedicationDispenseGroup() {
      this.fetchingMedicationDispenseGroup = true;
      this.$store.dispatch('fetchMedicationDispenseGroup', this.$route.params.medicationDispenseGroupId)
        .then(medicationDispenseGroup => {
          this.medicationDispenseGroup = medicationDispenseGroup;
        })
        .catch(e => {
          this.$router.push(this.medicationRequestLink);
        })
        .finally(() => {
          this.fetchingMedicationDispenseGroup = false;
        });
    }
  }
};
</script>

<style lang="scss">
.medication-dispense-group-view {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }

  &__title {
    color: $--color-white;
    margin: $--spacing-6 0;
  }

  &__loader {
    min-height: 75vh;
  }

  &__body {
    .card {
      margin-bottom: $--spacing-4;
    }
  }
}
</style>
